import { useEffect, useState } from "react";
import Button from "../common/Button";
import IncentiveClaimFormSection from "./IncentiveClaimFormSection";
import IncentiveClaimFormSubSection from "./IncentiveClaimFormSubSection";
import { useNavigate } from "react-router-dom";
import { applyIncentiveClaimFields } from "../../forms/incentiveClaimApplicationFields";
import { validateSingleSectionFormData } from "../../utils/utils";
import api from "../../api/ApiService";
import { getStoredItem, setStoredItem } from "../../config/storageUtils";
import { applicationStatusMap } from "../../config/applicationStatusConfig";
import { installmentsTypes } from "../../config/appliedSchemesConfig";
import { useLanguage } from "../LanguageProvider/LanguageProvider";

const ApplyIncentiveClaimForm = () => {
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [incentiveClaimDropdownData, setIncentiveClaimDropdownData] = useState(
    {}
  );
  const { language, setLanguage } = useLanguage();

  useEffect(() => {
    getIncentiveClaimDropdownData();
  }, []);

  const getIncentiveClaimDropdownData = async () => {
    const data = await api.get("/incentive-claims-dropdown");
    if (data.status === 200) {
      setIncentiveClaimDropdownData(data.data);
    }
  };

  const handleNext = async () => {
    const { errors, isValid } = validateSingleSectionFormData(
      applyIncentiveClaimFields,
      formData
    );
    setErrors(errors);
    if (isValid) {
      const resp = await api.post("/applications/generate", {
        category_id: 1,
        invest_claim_id: parseInt(formData.financial_incentive_claim),
      });

      if (resp.status === 200) {
        navigate(`/incentive-claim-form/${resp.data.application_details.id}`);
      } else {
        setErrors("Error applying Application.");
      }
    }
  };

  const handleChange = (e) => {
    setErrors((prev) => ({ ...prev, [e.target.name]: null }));
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <IncentiveClaimFormSection language={language}>
      <div className="flex flex-wrap mx-2">
        {applyIncentiveClaimFields?.map((section, index) => (
          <IncentiveClaimFormSubSection
            key={index}
            sectionHeading={language ? section.title.hi : section.title.en}
            sectionFields={section.fields}
            formData={formData}
            handleChange={handleChange}
            errors={errors}
            language={language}
          />
        ))}
        <div className="w-full text-right mb-4">
          <Button className="bg-btn px-6 py-2 rounded" onClick={handleNext}>
            {language ? "अगला" : "Next"}
          </Button>
        </div>
      </div>
    </IncentiveClaimFormSection>
  );
};

export default ApplyIncentiveClaimForm;
